import { createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';

import { USER_TYPES } from '../Constant/Enums';

import { prepareFirebaseAuth } from './firebaseClients';

const mapFirebaseUser = user => ({
  uid: user.uid,
  name: user.displayName,
  email: user.email,
  emailVerified: user.emailVerified,
  phoneNumber: user.phoneNumber,
  photoURL: user.photoURL,
  createdAt: user.metadata.creationTime,
});

const Firebase = {
  createNewUser: async ({ email, password }) => {
    try {
      const auth = await prepareFirebaseAuth(USER_TYPES.USER);
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);

      return {
        data: mapFirebaseUser(userCredential.user),
        errors: null,
      };
    } catch (error) {
      return { data: null, errors: error.code };
    }
  },
  signIn: async (email, password) => {
    try {
      const auth = await prepareFirebaseAuth(USER_TYPES.USER);
      const response = await signInWithEmailAndPassword(auth, email, password);

      return {
        data: mapFirebaseUser(response.user),
        errors: null,
      };
    } catch (error) {
      return { data: null, errors: error.code };
    }
  },
};

export default Firebase;
